import { render } from "./SweetAlert.vue?vue&type=template&id=549753b8"
import script from "./SweetAlert.vue?vue&type=script&lang=js"
export * from "./SweetAlert.vue?vue&type=script&lang=js"

import "./SweetAlert.vue?vue&type=style&index=0&id=549753b8&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__